'use client';

import { Button } from '@/components/ui/Button';
import { Section, SectionHeading } from '@/components/ui/Section';
import { ROUTES } from '@/config/routes';
import { AFFILIATE_PLATFORMS } from '@/data/affiliates';

import { AffiliateCard } from './AffiliateCard';

export function AffiliateShowcase({ showCta = true, tone = 'default' }: { showCta?: boolean; tone?: 'default' | 'raised' }) {
  return (
    <Section id="affiliates" tone={tone}>
      <SectionHeading
        eyebrow="Licensed affiliates"
        title="The platforms we market — and the codes that pay you"
        description="Every LaunchPad ships with your affiliate codes preconfigured. Run one platform or rotate all three on the same screen and keep the commissions from each."
      />

      <div className="mt-14 grid gap-6 lg:grid-cols-3">
        {AFFILIATE_PLATFORMS.map((platform) => (
          <AffiliateCard key={platform.id} platform={platform} />
        ))}
      </div>

      {showCta ? (
        <div className="mt-10 flex justify-center">
          <Button variant="secondary" to={ROUTES.affiliates}>
            See all affiliate platforms & request a code
          </Button>
        </div>
      ) : null}
    </Section>
  );
}
